import {
  GET_SCM_DETAILS_FAILURE,
  GET_SCM_DETAILS_LOADING,
  GET_SCM_DETAILS_SUCCESS,
} from "../../actions/types";

const initialState = {
  scmDetails: {
    get: {
      loading: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const getScmDetailReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCM_DETAILS_LOADING:
      return {
        ...state,
        scmDetails: {
          ...state.scmDetails,
          get: {
            ...state.scmDetails.get,
            loading: true,
            reset: false,
            success: {
              ...state.scmDetails.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };

    case GET_SCM_DETAILS_SUCCESS:
      return {
        ...state,
        scmDetails: {
          ...state.scmDetails,
          get: {
            ...state.scmDetails.get,
            loading: false,
            reset: false,
            success: {
              ...state.scmDetails.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_SCM_DETAILS_FAILURE:
      return {
        ...state,
        scmDetails: {
          ...state.scmDetails,
          get: {
            ...state.scmDetails.get,
            loading: false,
            reset: false,
            success: {
              ...state.scmDetails.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    default:
      return state;
  }
};

export default getScmDetailReducers;
